import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ContactCTABand() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-brand-700 via-brand-600 to-secondary-700">
      <div
        ref={ref}
        className={`container-page relative z-10 scroll-reveal ${revealed ? 'revealed' : ''}`}
      >
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-paper-50 mb-4">
            Ready to Partner With Us?
          </h2>
          <p className="text-brand-100/80 max-w-xl mx-auto mb-8 text-sm md:text-base">
            Join 340+ warehouses, 2,500+ vehicles, and thousands of buyers and
            sellers already on the Freshhlock network.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/storage"
              className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Storage
            </Link>
            <Link
              to="/wholesale"
              className="px-8 py-3.5 border border-paper-50/40 hover:border-paper-50/80 text-paper-50 font-medium text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Visit Wholesale
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}